/* eslint-disable */
// biome-ignore-all lint: auto-generated
//
// This file is auto-generated by autoexport.
// Do not modify manually, please do: vp run check.
//
// plugin: TypeScriptEncoder
// source: public/types/Types.ts

import type { Bytes, CMYKColor, Distance, DistanceMargins, DistancePathPoint, DistancePoint, DistanceRectangle, DrawnPageResult, GetBlockPointer, HorizontalAlign, ICCPointer, IsDataAvailPointer, Margins, MergePage, PageNumber, PdfReaderPointer, Pixel, PlotColor, PlotFile, PlotLayer, PlotMatrix, PlotPage, PlotPageEntry, PlotRaster, PlotShape, PlotShapeGroup, PlotShapeMedia, PlotShapePath, PlotShapeRect, PlotShapeText, RGBColor, Rectangle, SpotColor, VerticalAlign } from "../public/types/Types"
import type { Result } from "@pdfking/errors"
import { NullQ } from "@pdfking/structs"
import { Failure, Success } from "@pdfking/errors"
import type { RuntimeBridge, Cursor, Writer } from "@pdfking/library-core"
import { CreateWriter, write_buf, call_with, call_void, call_start, call_next, gen_cb } from "@pdfking/library-core"

export const NativeSymbols: Record<string, "std" | "next"> = {
  $3: "std",
  $4: "std",
  $5: "std",
  $6: "std",
  $7: "std",
  $8: "std",
  $9: "std",
  $a: "std",
  $b: "std",
  $c: "std",
  $d: "std",
  $e: "next",
  $f: "std",
  $g: "std",
  $h: "std",
  $i: "std",
  $j: "std",
  $k: "std",
  $l: "std",
}

const enc_HorizontalAlign_m: Record<string, bigint> = {
  center: 14849264025743704514n,
  left: 15653723452225789001n,
  right: 15122148005584593591n,
}

const enc_VerticalAlign_m: Record<string, bigint> = {
  bottom: 9415359842913895796n,
  center: 14849264025743704514n,
  top: 9059173479966262516n,
}

function dec_27mxbi3r7k7ol(c: Cursor) {
  switch (c.u32()) {
    case 0:
      return Success(BigInt(c.ptr()) as PdfReaderPointer)
    default:
      return Failure(c.str())
  }
}

function dec_ft0r4xhubs8n(c: Cursor) {
  switch (c.u32()) {
    case 0:
      return Success(c.bool())
    default:
      return Failure(c.str())
  }
}

function dec_2lqnokmzypd36(c: Cursor) {
  switch (c.u32()) {
    case 0:
      return Success(c.bytes())
    default:
      return Failure(c.str())
  }
}

function dec_epnaewwn23z2(c: Cursor) {
  switch (c.u32()) {
    case 0:
      return Success(dec_DrawnPageResult(c))
    default:
      return Failure(c.str())
  }
}

function dec_DrawnPageResult(c: Cursor) {
  return { bytes: c.bytes(), colors: dec_2mprq3yqcjsmm(c), media: dec_MediaInfo(c), transparency: c.bool() }
}

function dec_2mprq3yqcjsmm(c: Cursor) {
  return Array.from({ length: c.u32() }, () => c.str())
}

function dec_MediaInfo(c: Cursor) {
  return { bleed: dec_Margins(c), trim: dec_Rectangle(c) }
}

function dec_Margins(c: Cursor) {
  return { bottom: c.f64() as Pixel, left: c.f64() as Pixel, right: c.f64() as Pixel, top: c.f64() as Pixel }
}

function dec_Rectangle(c: Cursor) {
  return { height: c.f64() as Pixel, width: c.f64() as Pixel }
}

function dec_qnmr4oidmmrn(c: Cursor) {
  switch (c.u32()) {
    case 0:
      return Success(BigInt(c.ptr()) as ICCPointer)
    default:
      return Failure(c.str())
  }
}

function dec_PlotMatrix(c: Cursor): PlotMatrix {
  return [c.f64(), c.f64(), c.f64(), c.f64(), c.f64() as Distance, c.f64() as Distance]
}

function dec_DistanceMargins(c: Cursor) {
  return {
    bottom: c.f64() as Distance,
    left: c.f64() as Distance,
    right: c.f64() as Distance,
    top: c.f64() as Distance,
  }
}

function dec_18w4qij4ulh43(c: Cursor) {
  return Array.from({ length: c.u32() }, () => dec_PlotShape(c))
}

function dec_PlotShape(c: Cursor): PlotShape {
  switch (c.u64()) {
    case 13231578370567648204n:
      return {
        enum: "plot_group" as Extract<PlotShape, { enum: "plot_group" }>["enum"],
        ...dec_PlotShapeGroup(c),
      }
    case 745757018129653294n:
      return {
        enum: "plot_media" as Extract<PlotShape, { enum: "plot_media" }>["enum"],
        ...dec_PlotShapeMedia(c),
      }
    case 13340920252464266009n:
      return { enum: "plot_path" as Extract<PlotShape, { enum: "plot_path" }>["enum"], ...dec_PlotShapePath(c) }
    case 13387738572657254657n:
      return { enum: "plot_rect" as Extract<PlotShape, { enum: "plot_rect" }>["enum"], ...dec_PlotShapeRect(c) }
    case 7579697394296625938n:
      return { enum: "plot_text" as Extract<PlotShape, { enum: "plot_text" }>["enum"], ...dec_PlotShapeText(c) }
    default:
      throw new Error("unknown PlotShape tag")
  }
}

function dec_PlotShapeGroup(c: Cursor) {
  return { matrix: dec_PlotMatrix(c), shapes: dec_18w4qij4ulh43(c) }
}

function dec_PlotShapeMedia(c: Cursor) {
  return {
    filename: c.str(),
    layer: c.str(),
    mask: dec_DistanceMargins(c),
    media_matrix: dec_PlotMatrix(c),
    page_number: Number(c.i64()) as PageNumber,
    position: dec_DistanceRectangle(c),
  }
}

function dec_DistanceRectangle(c: Cursor) {
  return {
    height: c.f64() as Distance,
    width: c.f64() as Distance,
    x: c.f64() as Distance,
    y: c.f64() as Distance,
  }
}

function dec_PlotShapePath(c: Cursor) {
  return {
    closed: c.bool(),
    fill_color: c.str(),
    layer: c.str(),
    points: dec_1ry14q8w3ppgk(c),
    stroke_color: c.str(),
    stroke_width: c.f64() as Distance,
  }
}

function dec_1ry14q8w3ppgk(c: Cursor) {
  return Array.from({ length: c.u32() }, () => dec_DistancePathPoint(c))
}

function dec_DistancePathPoint(c: Cursor) {
  return {
    after: dec_DistancePoint(c),
    before: dec_DistancePoint(c),
    x: c.f64() as Distance,
    y: c.f64() as Distance,
  }
}

function dec_DistancePoint(c: Cursor) {
  return { x: c.f64() as Distance, y: c.f64() as Distance }
}

function dec_PlotShapeRect(c: Cursor) {
  return {
    fill_color: c.str(),
    layer: c.str(),
    position: dec_DistanceRectangle(c),
    stroke_color: c.str(),
    stroke_width: c.f64() as Distance,
  }
}

function dec_PlotShapeText(c: Cursor) {
  return {
    fill_color: c.str(),
    font_name: c.str(),
    font_size: c.f64() as Pixel,
    horizontal_align: dec_HorizontalAlign(c),
    layer: c.str(),
    position: dec_DistanceRectangle(c),
    stroke_color: c.str(),
    stroke_width: c.f64() as Distance,
    text: c.str(),
    text_color: c.str(),
    vertical_align: dec_VerticalAlign(c),
  }
}

function dec_HorizontalAlign(c: Cursor): HorizontalAlign {
  switch (c.u64()) {
    case 14849264025743704514n:
      return "center"
    case 15653723452225789001n:
      return "left"
    case 15122148005584593591n:
      return "right"
    default:
      throw new Error("unknown HorizontalAlign tag")
  }
}

function dec_VerticalAlign(c: Cursor): VerticalAlign {
  switch (c.u64()) {
    case 9415359842913895796n:
      return "bottom"
    case 14849264025743704514n:
      return "center"
    case 9059173479966262516n:
      return "top"
    default:
      throw new Error("unknown VerticalAlign tag")
  }
}

function enc_Margins(v: Margins, w: Writer): void {
  w.f64(v.bottom)
  w.f64(v.left)
  w.f64(v.right)
  w.f64(v.top)
}

function enc_Rectangle(v: Rectangle, w: Writer): void {
  w.f64(v.height)
  w.f64(v.width)
}

function enc_26a45xdx798xj(v: Readonly<Record<string, PlotColor>>, w: Writer): void {
  const ks = Object.keys(v)
  w.u32(ks.length)
  for (const k of ks) {
    const val = v[k]!
    w.str(k)
    enc_PlotColor(val, w)
  }
}

function enc_PlotColor(v: PlotColor, w: Writer): void {
  switch (v.enum) {
    case "cmyk":
      w.u64(11506283198264464647n)
      enc_CMYKColor(v, w)
      break
    case "rgb":
      w.u64(16758566120972881704n)
      enc_RGBColor(v, w)
      break
    case "spot":
      w.u64(12379147039062967618n)
      enc_SpotColor(v, w)
      break
  }
}

function enc_CMYKColor(v: CMYKColor, w: Writer): void {
  w.f64(v.alpha)
  w.f64(v.black)
  w.f64(v.cyan)
  w.f64(v.magenta)
  w.f64(v.yellow)
}

function enc_RGBColor(v: RGBColor, w: Writer): void {
  w.f64(v.alpha)
  w.f64(v.blue)
  w.f64(v.green)
  w.f64(v.red)
}

function enc_SpotColor(v: SpotColor, w: Writer): void {
  w.f64(v.alpha)
  w.f64(v.black)
  w.f64(v.cyan)
  w.f64(v.magenta)
  w.str(v.spot_name)
  w.f64(v.yellow)
}

function enc_PlotMatrix(v: PlotMatrix, w: Writer): void {
  w.f64(v[0])
  w.f64(v[1])
  w.f64(v[2])
  w.f64(v[3])
  w.f64(v[4])
  w.f64(v[5])
}

function enc_3v7lg6xbkrbnj(v: Readonly<Record<string, PlotLayer>>, w: Writer): void {
  const ks = Object.keys(v)
  w.u32(ks.length)
  for (const k of ks) {
    const val = v[k]!
    w.str(k)
    enc_PlotLayer(val, w)
  }
}

function enc_PlotLayer(v: PlotLayer, w: Writer): void {
  w.bool(v.locked)
  w.bool(v.printable)
  w.bool(v.visible)
}

function enc_PlotPage(v: PlotPage, w: Writer): void {
  enc_DistanceMargins(v.bleed, w)
  w.f64(v.height)
  enc_18w4qij4ulh43(v.shapes, w)
  w.f64(v.width)
}

function enc_DistanceMargins(v: DistanceMargins, w: Writer): void {
  w.f64(v.bottom)
  w.f64(v.left)
  w.f64(v.right)
  w.f64(v.top)
}

function enc_18w4qij4ulh43(v: PlotShape[], w: Writer): void {
  w.u32(v.length)
  for (const el of v) {
    enc_PlotShape(el, w)
  }
}

function enc_PlotShape(v: PlotShape, w: Writer): void {
  switch (v.enum) {
    case "plot_group":
      w.u64(13231578370567648204n)
      enc_PlotShapeGroup(v, w)
      break
    case "plot_media":
      w.u64(745757018129653294n)
      enc_PlotShapeMedia(v, w)
      break
    case "plot_path":
      w.u64(13340920252464266009n)
      enc_PlotShapePath(v, w)
      break
    case "plot_rect":
      w.u64(13387738572657254657n)
      enc_PlotShapeRect(v, w)
      break
    case "plot_text":
      w.u64(7579697394296625938n)
      enc_PlotShapeText(v, w)
      break
  }
}

function enc_PlotShapeGroup(v: PlotShapeGroup, w: Writer): void {
  enc_PlotMatrix(v.matrix, w)
  enc_18w4qij4ulh43(v.shapes, w)
}

function enc_PlotShapeMedia(v: PlotShapeMedia, w: Writer): void {
  w.str(v.filename)
  w.str(v.layer)
  enc_DistanceMargins(v.mask, w)
  enc_PlotMatrix(v.media_matrix, w)
  w.i64(BigInt(v.page_number))
  enc_DistanceRectangle(v.position, w)
}

function enc_DistanceRectangle(v: DistanceRectangle, w: Writer): void {
  w.f64(v.height)
  w.f64(v.width)
  w.f64(v.x)
  w.f64(v.y)
}

function enc_PlotShapePath(v: PlotShapePath, w: Writer): void {
  w.bool(v.closed)
  w.str(v.fill_color)
  w.str(v.layer)
  enc_1ry14q8w3ppgk(v.points, w)
  w.str(v.stroke_color)
  w.f64(v.stroke_width)
}

function enc_1ry14q8w3ppgk(v: DistancePathPoint[], w: Writer): void {
  w.u32(v.length)
  for (const el of v) {
    enc_DistancePathPoint(el, w)
  }
}

function enc_DistancePathPoint(v: DistancePathPoint, w: Writer): void {
  enc_DistancePoint(v.after, w)
  enc_DistancePoint(v.before, w)
  w.f64(v.x)
  w.f64(v.y)
}

function enc_DistancePoint(v: DistancePoint, w: Writer): void {
  w.f64(v.x)
  w.f64(v.y)
}

function enc_PlotShapeRect(v: PlotShapeRect, w: Writer): void {
  w.str(v.fill_color)
  w.str(v.layer)
  enc_DistanceRectangle(v.position, w)
  w.str(v.stroke_color)
  w.f64(v.stroke_width)
}

function enc_PlotShapeText(v: PlotShapeText, w: Writer): void {
  w.str(v.fill_color)
  w.str(v.font_name)
  w.f64(v.font_size)
  w.u64(enc_HorizontalAlign_m[v.horizontal_align]!)
  w.str(v.layer)
  enc_DistanceRectangle(v.position, w)
  w.str(v.stroke_color)
  w.f64(v.stroke_width)
  w.str(v.text)
  w.str(v.text_color)
  w.u64(enc_VerticalAlign_m[v.vertical_align]!)
}

function enc_PlotRaster(v: PlotRaster, w: Writer): void {
  enc_Margins(v.bleed, w)
  w.ptr(v.icc_handle)
  w.f64(v.resolution)
}

export const CreateFunctions = <T extends number | bigint>(i: RuntimeBridge<T>) => {
  function enc_1drvt9yiommpp(v: Uint8Array, w: Writer): void {
    const [ptr, len] = write_buf(i, v)
    w.ptr(ptr)
    w.ptr(len)
  }
  function enc_36o0jcjvrvcbl(v: Result<MergePage>, w: Writer): void {
    if (NullQ(v.error)) {
      w.u32(0)
      enc_MergePage(v.value!, w)
    } else {
      w.u32(1)
      w.str(String(v.error.enum))
    }
  }
  function enc_MergePage(v: MergePage, w: Writer): void {
    enc_1drvt9yiommpp(v.bytes, w)
    w.str(v.meta)
  }
  function enc_PlotPageEntry(v: PlotPageEntry, w: Writer): void {
    enc_26a45xdx798xj(v.color_map, w)
    enc_2flc60ge8qs2n(v.file_map, w)
    enc_3v7lg6xbkrbnj(v.layer_map, w)
    enc_PlotPage(v.page, w)
    if (NullQ(v.raster)) {
      w.bool(false)
    } else {
      w.bool(true)
      enc_PlotRaster(v.raster!, w)
    }
    w.f64(v.unit_to_px)
  }
  function enc_2flc60ge8qs2n(v: Readonly<Record<string, Readonly<Record<PageNumber, PlotFile>>>>, w: Writer): void {
    const ks = Object.keys(v)
    w.u32(ks.length)
    for (const k of ks) {
      const val = v[k]!
      w.str(k)
      enc_20k93mxlk50e(val, w)
    }
  }
  function enc_20k93mxlk50e(v: Readonly<Record<PageNumber, PlotFile>>, w: Writer): void {
    const ks = Object.keys(v)
    w.u32(ks.length)
    for (const k of ks) {
      const key = Number(k) as PageNumber
      const val = v[key]!
      w.i64(BigInt(key))
      enc_PlotFile(val, w)
    }
  }
  function enc_PlotFile(v: PlotFile, w: Writer): void {
    enc_1drvt9yiommpp(v.bytes, w)
    enc_PlotMatrix(v.matrix, w)
  }
  return {
    init: (): void => {
      const w = CreateWriter(i)
      call_void(i, "$3", w)
    },
    destroy: (): void => {
      const w = CreateWriter(i)
      call_void(i, "$4", w)
    },
    open: (file_len: Bytes, get_block_ptr: GetBlockPointer, is_data_avail_ptr: IsDataAvailPointer): Result<PdfReaderPointer> => {
      const w = CreateWriter(i)
      w.i64(BigInt(file_len))
      w.ptr(get_block_ptr)
      w.ptr(is_data_avail_ptr)
      return call_with(i, "$5", w, dec_27mxbi3r7k7ol)
    },
    doc_avail: (reader_handle: PdfReaderPointer): Result<boolean> => {
      const w = CreateWriter(i)
      w.ptr(reader_handle)
      return call_with(i, "$6", w, dec_ft0r4xhubs8n)
    },
    page_avail: (reader_handle: PdfReaderPointer, page_index: PageNumber): Result<boolean> => {
      const w = CreateWriter(i)
      w.ptr(reader_handle)
      w.i64(BigInt(page_index))
      return call_with(i, "$7", w, dec_ft0r4xhubs8n)
    },
    page_count: (reader_handle: PdfReaderPointer): bigint => {
      const w = CreateWriter(i)
      w.ptr(reader_handle)
      return call_with(i, "$8", w, (c) => c.i64())
    },
    open_custom: (file_len: Bytes, get_block_ptr: GetBlockPointer): Result<PdfReaderPointer> => {
      const w = CreateWriter(i)
      w.i64(BigInt(file_len))
      w.ptr(get_block_ptr)
      return call_with(i, "$9", w, dec_27mxbi3r7k7ol)
    },
    open_mem: (data: Uint8Array): Result<PdfReaderPointer> => {
      const w = CreateWriter(i)
      const [a0_ptr, a0_len] = write_buf(i, data)
      w.ptr(a0_ptr)
      w.ptr(a0_len)
      return call_with(i, "$a", w, dec_27mxbi3r7k7ol)
    },
    close_mem: (reader_handle: PdfReaderPointer): Result<boolean> => {
      const w = CreateWriter(i)
      w.ptr(reader_handle)
      return call_with(i, "$b", w, dec_ft0r4xhubs8n)
    },
    close: (reader_handle: PdfReaderPointer): Result<boolean> => {
      const w = CreateWriter(i)
      w.ptr(reader_handle)
      return call_with(i, "$c", w, dec_ft0r4xhubs8n)
    },
    merge: function*(pages: Generator<MergePage>, start_offset: bigint): Generator<Result<Uint8Array>> {
      const cbs: { free: () => void }[] = []
      const cb: T[] = []
      const cbpages = gen_cb(i, pages, enc_36o0jcjvrvcbl)
      cbs.push(cbpages)
      cb.push(cbpages.pointer)
      const w = CreateWriter(i)
      w.ptr(cb[0]!)
      w.i64(start_offset)
      const handle = call_start(i, "$d", w)
      try {
        yield* call_next(i, "$e", handle, dec_2lqnokmzypd36)
      } finally {
        for (const cb of cbs) {
          cb.free()
        }
      }
    },
    shared_update: (trailer: Uint8Array, shared: Uint8Array, at: bigint, length: bigint): Result<Uint8Array> => {
      const w = CreateWriter(i)
      const [a0_ptr, a0_len] = write_buf(i, trailer)
      w.ptr(a0_ptr)
      w.ptr(a0_len)
      const [a1_ptr, a1_len] = write_buf(i, shared)
      w.ptr(a1_ptr)
      w.ptr(a1_len)
      w.i64(at)
      w.i64(length)
      return call_with(i, "$f", w, dec_2lqnokmzypd36)
    },
    split_page: (reader_handle: PdfReaderPointer, page_index: PageNumber): Result<DrawnPageResult> => {
      const w = CreateWriter(i)
      w.ptr(reader_handle)
      w.i64(BigInt(page_index))
      return call_with(i, "$g", w, dec_epnaewwn23z2)
    },
    convert_jpeg: (data: Uint8Array, resolution: Pixel): Result<DrawnPageResult> => {
      const w = CreateWriter(i)
      const [a0_ptr, a0_len] = write_buf(i, data)
      w.ptr(a0_ptr)
      w.ptr(a0_len)
      w.f64(resolution)
      return call_with(i, "$h", w, dec_epnaewwn23z2)
    },
    convert_bitmap: (bgra: Uint8Array, size: Rectangle, resolution: Pixel): Result<DrawnPageResult> => {
      const w = CreateWriter(i)
      const [a0_ptr, a0_len] = write_buf(i, bgra)
      w.ptr(a0_ptr)
      w.ptr(a0_len)
      enc_Rectangle(size, w)
      w.f64(resolution)
      return call_with(i, "$i", w, dec_epnaewwn23z2)
    },
    icc_create: (data: Uint8Array): Result<ICCPointer> => {
      const w = CreateWriter(i)
      const [a0_ptr, a0_len] = write_buf(i, data)
      w.ptr(a0_ptr)
      w.ptr(a0_len)
      return call_with(i, "$j", w, dec_qnmr4oidmmrn)
    },
    icc_destroy: (handle: ICCPointer): Result<boolean> => {
      const w = CreateWriter(i)
      w.ptr(handle)
      return call_with(i, "$k", w, dec_ft0r4xhubs8n)
    },
    plot: (entry: PlotPageEntry): Result<DrawnPageResult> => {
      const w = CreateWriter(i)
      enc_PlotPageEntry(entry, w)
      return call_with(i, "$l", w, dec_epnaewwn23z2)
    },
  }
}
